"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseXmlString = exports.makeEmptyDom = exports.buildXmlDom = void 0;

var _element = require("./element.apply");

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var getDomParser = function getDomParser(parser) {
  if (parser) {
    return parser;
  }

  if (_typeof('window') === 'object') {
    var p = window.DOMParser;

    if (p) {
      return new p();
    }
  }

  throw new Error('No DOM parser available. Must supply a DOM parser if window.DOMParser is not available.');
};

var parseXmlString = function parseXmlString(xml) {
  var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return getDomParser(parser).parseFromString(xml, 'text/xml');
};

exports.parseXmlString = parseXmlString;

var makeEmptyDom = function makeEmptyDom() {
  var parser = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var dom = parseXmlString('<n />', parser);
  dom.removeChild(dom.documentElement);
  return dom;
}; // (DOMDocument -> DOMElement, Options) -> DOMDocument


exports.makeEmptyDom = makeEmptyDom;

var buildXmlDom = function buildXmlDom(buildRoot) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      parser = _ref.parser;

  var dom = makeEmptyDom(parser);
  var roots = buildRoot(dom);
  (0, _element.applyChildren)(dom, Array.isArray(roots) ? roots : [roots]);
  return dom;
};

exports.buildXmlDom = buildXmlDom;